import { render, staticRenderFns } from "./UsersModal.vue?vue&type=template&id=bb4caa80&scoped=true"
import script from "./UsersModal.vue?vue&type=script&lang=js"
export * from "./UsersModal.vue?vue&type=script&lang=js"
import style0 from "./UsersModal.vue?vue&type=style&index=0&id=bb4caa80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4caa80",
  null
  
)

export default component.exports